export default __webpack_public_path__ + "static/media/not-found.8d3c0cf3.png";